import React from "react"
import { Box, Text } from "@chakra-ui/react"

interface LaunchMessagesProps {
  launchSuccess: boolean
  launchError: boolean
  getCompanyError: boolean
  launchedCompanies: { id: number; name: string }[]
}

export function LaunchMessages({
  launchSuccess,
  launchError,
  getCompanyError,
  launchedCompanies
}: LaunchMessagesProps): JSX.Element {
  return (
    <>
      {launchSuccess && (
        <Box bg="green.50" borderWidth="1px" borderColor="green.200" borderRadius="md" p={4} mb={4}>
          <Text fontSize="md" color="green.700">
            Carrot Card was successfully launched in the following segments:{" "}
            {launchedCompanies.map((company) => `${company.name} (${company.id})`).join(", ")}.
          </Text>
        </Box>
      )}
      {launchError && (
        <Box bg="red.50" borderWidth="1px" borderColor="red.200" borderRadius="md" p={4} mb={4}>
          <Text fontSize="md" color="red.700">
            There was an issue launching Carrot Card. Please try again and contact eng support if the error persists.
          </Text>
        </Box>
      )}
      {getCompanyError && (
        <Box bg="red.50" borderWidth="1px" borderColor="red.200" borderRadius="md" p={4} mb={4}>
          <Text fontSize="md" color="red.700">
            There was an issue fetching the company data. Please try again and contact eng support if the error
            persists.
          </Text>
        </Box>
      )}
    </>
  )
}
